"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _bi = require("react-icons/bi");

var _constants = require("../constants");

var _checkbox = _interopRequireDefault(require("../../checkbox"));

var _typography = _interopRequireDefault(require("../../typography"));

var _labelIcon = require("./labelIcon");

var _radio = require("../../radio/radio");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.tree-view-node-parent-node-container {\n  height: 3rem; }\n  .tree-view-node-parent-node-container-remove-padding {\n    height: unset; }\n  .tree-view-node-parent-node-container-single-environment-select {\n    width: 100%; }\n    .tree-view-node-parent-node-container-single-environment-select-checked {\n      background-color: #e0e0e0; }\n    .tree-view-node-parent-node-container-single-environment-select:hover {\n      background-color: #e0e0e0;\n      cursor: pointer; }\n\n.tree-view-node-container {\n  height: fit-content;\n  min-width: 19rem;\n  position: relative; }\n\n.tree-view-node-container:first-child {\n  margin-left: 0; }\n\n.tree-view-node-parent-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-width: 0;\n  padding: 0.75rem 1rem;\n  height: 3rem;\n  box-sizing: border-box; }\n  .tree-view-node-parent-container-remove-padding {\n    height: unset;\n    padding: unset; }\n  .tree-view-node-parent-container .tree-view-node-content {\n    display: flex;\n    align-items: center; }\n\n.tree-view-node-parent-icon {\n  margin-right: 0.5rem;\n  display: flex;\n  align-items: center; }\n\n.tree-view-node-parent-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  min-width: 0;\n  color: #393939;\n  font-family: \"OpenSansRegular\";\n  font-size: 0.875rem;\n  letter-spacing: 0.02rem;\n  margin-right: 0.5rem; }\n\n.tree-view-node-parent-icon {\n  color: #6f6f6f; }\n\n.tree-view-node-left-empty-padding {\n  margin-left: 1.5rem; }\n\n.tree-view-table-name-cell-content {\n  display: flex;\n  gap: 0.375rem; }\n\n.tree-view-node-disabled .tree-view-node-parent-text {\n  color: #a8a8a8; }\n\n.tree-view-node-disabled .tree-view-node-dir-icon {\n  color: #a8a8a8; }\n\n.tree-view-node-disabled:hover {\n  background-color: transparent;\n  cursor: not-allowed; }\n";
  var fileName = "compone_treeNodes";
  var element = document.querySelector("style[data-sass-component='compone_treeNodes']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var DirectionIcon = function DirectionIcon(_ref) {
  var expanded = _ref.expanded;
  return expanded ? /*#__PURE__*/_react.default.createElement(_bi.BiChevronDown, {
    size: _constants.defaultIconSize
  }) : /*#__PURE__*/_react.default.createElement(_bi.BiChevronRight, {
    size: _constants.defaultIconSize
  });
};

var Node = function Node(_ref2) {
  var _node$_children, _parentNodeClass, _textNodeClass, _node$leftIcon, _node$leftIcon2, _node$leftIcon3, _node$leftIcon4, _node$rightIcon, _node$rightIcon2, _node$rightIcon3;

  var node = _ref2.node,
      expandIconClickHandler = _ref2.expandIconClickHandler,
      handleCheckboxClick = _ref2.handleCheckboxClick,
      readOnly = _ref2.readOnly,
      hideCheckboxes = _ref2.hideCheckboxes,
      _ref2$singleSelect = _ref2.singleSelect,
      singleSelect = _ref2$singleSelect === void 0 ? false : _ref2$singleSelect,
      _ref2$singleSelectRad = _ref2.singleSelectRadio,
      singleSelectRadio = _ref2$singleSelectRad === void 0 ? false : _ref2$singleSelectRad,
      _ref2$allowOnlyLeafSe = _ref2.allowOnlyLeafSelection,
      allowOnlyLeafSelection = _ref2$allowOnlyLeafSe === void 0 ? false : _ref2$allowOnlyLeafSe,
      _ref2$allowRootSelect = _ref2.allowRootSelection,
      allowRootSelection = _ref2$allowRootSelect === void 0 ? true : _ref2$allowRootSelect,
      _ref2$removeNodePaddi = _ref2.removeNodePadding,
      removeNodePadding = _ref2$removeNodePaddi === void 0 ? false : _ref2$removeNodePaddi;
  var isLeaf = node.type === 'leaf';
  var hasChildren = (node === null || node === void 0 ? void 0 : (_node$_children = node._children) === null || _node$_children === void 0 ? void 0 : _node$_children.length) > 0;
  var isRootNode = node._id === '0';
  var isRowDisable = singleSelect && singleSelectRadio && (node === null || node === void 0 ? void 0 : node.disabled); // The root node is always selectable.

  var shouldHighlightNode = (isLeaf || allowRootSelection && isRootNode) && singleSelect;
  var parentNodeClass = (_parentNodeClass = {}, _defineProperty(_parentNodeClass, _constants.TreeNodeClasses.parentNodeContainer, true), _defineProperty(_parentNodeClass, _constants.TreeNodeClasses.parentNodeContainerSingleEnvironmentSelect, allowOnlyLeafSelection ? shouldHighlightNode : singleSelect), _defineProperty(_parentNodeClass, _constants.TreeNodeClasses.parentNodeContainerSingleEnvironmentSelectChecked, allowOnlyLeafSelection ? shouldHighlightNode && node.checked : singleSelect && node.checked), _defineProperty(_parentNodeClass, _constants.TreeNodeClasses.parentNodeContainerRemovePadding, removeNodePadding), _defineProperty(_parentNodeClass, _constants.TreeNodeClasses.disabledRow, isRowDisable), _parentNodeClass);
  var textNodeClass = (_textNodeClass = {}, _defineProperty(_textNodeClass, _constants.TreeNodeClasses.parentText, true), _defineProperty(_textNodeClass, _constants.TreeNodeClasses.disabledRow, isRowDisable), _textNodeClass);

  var handleEnvironmentClick = function handleEnvironmentClick() {
    if (singleSelect && singleSelectRadio && node !== null && node !== void 0 && node.disabled) {
      return;
    }

    if (!singleSelect) {
      return;
    }

    if (allowOnlyLeafSelection && !isLeaf && !(allowRootSelection && isRootNode)) {
      return;
    }

    handleCheckboxClick({
      id: node._id,
      checked: true
    });
  };

  var renderDirectionalIcon = function renderDirectionalIcon() {
    if (hasChildren) {
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-testid": "directional-icon-".concat(node._id),
        className: _constants.TreeNodeClasses.dirIconContainer,
        onClick: function onClick(e) {
          e.stopPropagation();
          expandIconClickHandler(node._id);
        }
      }, /*#__PURE__*/_react.default.createElement(DirectionIcon, {
        expanded: node.expanded
      }));
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "tree-node-".concat(node._id),
    className: (0, _classnames.default)(_objectSpread({}, parentNodeClass)),
    style: {
      paddingLeft: "".concat(isLeaf ? (node._depth + 1) * 34 - 9 : node._depth * 34, "px")
    },
    onClick: handleEnvironmentClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_constants.TreeNodeClasses.parentContainer, " ").concat(removeNodePadding ? _constants.TreeNodeClasses.parentContainerRemovePadding : '')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.TreeNodeClasses.treeNodeContent
  }, !isLeaf ? renderDirectionalIcon() : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_constants.TreeNodeClasses.parentIcon, " ").concat(!removeNodePadding && !isLeaf && !hasChildren ? _constants.TreeNodeClasses.nodeLeftemptyPadding : '')
  }, !hideCheckboxes && !singleSelect && /*#__PURE__*/_react.default.createElement(_checkbox.default, {
    name: "checkbox",
    disabled: readOnly || node.disabled,
    checked: node.checked || false,
    indeterminate: node.indeterminate,
    onChange: function onChange(_ref3) {
      var target = _ref3.target;
      handleCheckboxClick({
        id: node._id,
        checked: target.checked
      });
    }
  }), singleSelectRadio && singleSelect && /*#__PURE__*/_react.default.createElement(_radio.RadioButton, {
    onChange: function onChange(event) {
      handleCheckboxClick({
        id: node._id,
        checked: event.target.checked
      });
    },
    selected: node === null || node === void 0 ? void 0 : node.checked,
    disabled: node === null || node === void 0 ? void 0 : node.disabled
  }), /*#__PURE__*/_react.default.createElement(_labelIcon.LabelIcon, {
    isLeaf: isLeaf,
    iconSource: node === null || node === void 0 ? void 0 : (_node$leftIcon = node.leftIcon) === null || _node$leftIcon === void 0 ? void 0 : _node$leftIcon.icon,
    tooltip: node === null || node === void 0 ? void 0 : (_node$leftIcon2 = node.leftIcon) === null || _node$leftIcon2 === void 0 ? void 0 : _node$leftIcon2.tooltip,
    useDefaultIcon: node !== null && node !== void 0 && (_node$leftIcon3 = node.leftIcon) !== null && _node$leftIcon3 !== void 0 && _node$leftIcon3.icon ? false : true,
    onClick: node === null || node === void 0 ? void 0 : (_node$leftIcon4 = node.leftIcon) === null || _node$leftIcon4 === void 0 ? void 0 : _node$leftIcon4.onClick,
    disabled: singleSelect && singleSelectRadio && (node === null || node === void 0 ? void 0 : node.disabled)
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, textNodeClass))
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: !isLeaf || node.highlighted ? 'label2' : 'label1'
  }, node.label, " ", node.highlighted ? '*' : '')), /*#__PURE__*/_react.default.createElement(_labelIcon.LabelIcon, {
    iconSource: node === null || node === void 0 ? void 0 : (_node$rightIcon = node.rightIcon) === null || _node$rightIcon === void 0 ? void 0 : _node$rightIcon.icon,
    tooltip: node === null || node === void 0 ? void 0 : (_node$rightIcon2 = node.rightIcon) === null || _node$rightIcon2 === void 0 ? void 0 : _node$rightIcon2.tooltip,
    onClick: node === null || node === void 0 ? void 0 : (_node$rightIcon3 = node.rightIcon) === null || _node$rightIcon3 === void 0 ? void 0 : _node$rightIcon3.onClick
  }))));
};

var _default = Node;
exports.default = _default;